import { render, staticRenderFns } from "./IoTDataClient.component.vue?vue&type=template&id=a3ca81c4&scoped=true"
import script from "./IoTDataClient.component.ts?vue&type=script&lang=js&external"
export * from "./IoTDataClient.component.ts?vue&type=script&lang=js&external"
import style0 from "./IoTDataClient.component.vue?vue&type=style&index=0&id=a3ca81c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ca81c4",
  null
  
)

export default component.exports